export const addGirviPayment = async (girviPaymentData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "addGirviPayments", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, ...girviPaymentData})
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data = girviPaymentData;
        data.id = jsonResponse?.data?.id;
        jsonResponse.data = data;
    }
    console.log('Add Girvi Payment Response:', response);
    return jsonResponse;
};
export const updateGirviPayment = async (girviPaymentId, girviPaymentData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "updateGirviPayments", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: girviPaymentId, ...girviPaymentData})
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data = girviPaymentData;
        data.id = girviPaymentId;
        jsonResponse.data = data;
    }
    console.log('Update Girvi Payment Response:', response);
    return jsonResponse;
};
export const deleteGirviPayment = async (girviPaymentId) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({action: "deleteGirviPayments", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: girviPaymentId})
    });
    return await response.json();
};
